export const ToolbarButtonDivider = () => {
  return <div className="h-5 w-px border-r" />;
};
